import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer, inject } from 'mobx-react'

import Loader from '../../shared/components/Loader'
import Icon from '../../shared/components/Icon'

import HistoryListEntry from '../components/HistoryListEntry'

@inject('message', 'auth') @observer
export default
class MessageHistory extends Component {

  static propTypes = {
    auth: PropTypes.object,
    id: PropTypes.number,
    initialMessage: PropTypes.node,
    message: PropTypes.object,
    type: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  componentDidMount() {
    const { message, type, id } = this.props
    message.loadRegarding(type, id)
  }

  @autobind
  onToggleHistory() {
    this.setState({
      open: !this.state.open
    })
  }

  renderInitialMessage() {

    const { initialMessage } = this.props

    return (
      <div
        className="message-entry"
      >
        {initialMessage || 'Bisher keine Nachrichten'}
      </div>
    )

  }

  renderMessageList() {

    const {
      auth, message, type, id
    } = this.props
    const isAdmin = auth.acs.isAuthorized('ADMIN')

    let messages = message.whereRegarding(type, id)

    if (!messages.length) {
      return this.renderInitialMessage()
    }

    messages = messages.map((currMessage) => {
      let saveMessage = currMessage.message
      const senderId = (currMessage.sender && currMessage.sender.id)
        || currMessage.senderUserId

      switch (currMessage.type) {
        case 'released':
        case 'changed':
          if (!isAdmin) {
            saveMessage = ''
          }
          break
        default:
      }

      return {
        id: currMessage.id,
        sender: currMessage.sender,
        recipient: currMessage.recipient,
        subject: currMessage.subject,
        message: saveMessage,
        type: currMessage.type,
        senderId,
        isMe: senderId === auth.user.id,
        sendDate: currMessage.createdAt
      }
    })

    return messages
      .reverse()
      .map((currMessage) => {
        return (
          <HistoryListEntry
            message={currMessage}
            key={`message-${currMessage.id}`}
          />
        )
      })

  }

  renderLoader() {
    return (<Loader>Nachrichten werden geladen</Loader>)
  }

  render() {

    const { message } = this.props
    const { open } = this.state

    return (
      <div
        className={[
          'history-container',
          open ? 'vertical' : ''
        ].join(' ').trim()}
      >
        <button
          className={[
            'opener',
            'btn',
            'btn-default',
            open ? 'active' : ''
          ].join(' ').trim()}
          title="Nachrichtenverlauf ein-/ausblenden"
          onClick={this.onToggleHistory}
        >
          {message.loading
            ? (
              <Loader
                noFadeIn
                size={17}
              />
            )
            : (
              <Icon
                className="tool-icon"
                size={18}
                name="envelope-turquoise"
              />
            )}
        </button>
        <div
          className={[
            'vertical',
            'history',
            open ? '' : 'hidden'
          ].join(' ').trim()}
        >
          <h5>Nachrichtenhistorie</h5>
          <div className="content vertical v-scrollable">
            {message.loading
              ? this.renderLoader()
              : this.renderMessageList()}
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/message/containers/MessageHistory.js